function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getSRRIByName } from '@finect/front-resources/RiskProfile';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Section } from '../../Section';
import { PillModal } from '../../Pills';
import { SrriScale } from './../../Products/SrriScale';
import { Inner, InvestorProfile } from './partials';
export var FundSRRI = function (_React$Component) {
  _inherits(FundSRRI, _React$Component);
  var _super = _createSuper(FundSRRI);
  function FundSRRI() {
    var _this;
    _classCallCheck(this, FundSRRI);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      pillOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "handlePillLinkClick", function (event) {
      event.preventDefault();
      _this.setState({
        pillOpen: true
      });
    });
    return _this;
  }
  _createClass(FundSRRI, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        theme = _this$props.theme,
        fund = _this$props.fund,
        user = _this$props.user,
        bottomMargin = _this$props.bottomMargin,
        _this$props$hiddenIfE = _this$props.hiddenIfEmptySRRI,
        hiddenIfEmptySRRI = _this$props$hiddenIfE === void 0 ? true : _this$props$hiddenIfE;
      var pillOpen = this.state.pillOpen;
      var _theme$partner$consum = theme.partner.consumer,
        consumer = _theme$partner$consum === void 0 ? 'finect' : _theme$partner$consum;
      var srri = fund.srri;
      var risk = user ? user.risk : null;
      var pill = "".concat(getSuperPartnerBaseURL(), "/pills/es_ES/").concat(consumer, "/default/conoce-tu-perfil-inversor");
      var pillModal = "".concat(getSuperPartnerBaseURL(), "/pills/es_ES/").concat(consumer, "/embedded/conoce-tu-perfil-inversor/steps/age");
      var investorProfile = "".concat(getSuperPartnerBaseURL(), "/tus-finanzas#investorProfile");
      var userRisk = risk && risk.valoration ? getSRRIByName(risk.valoration) : null;
      if (hiddenIfEmptySRRI && !srri) return null;
      return React.createElement(Fragment, null, React.createElement(PillModal, {
        pill: pillModal,
        open: pillOpen,
        onClose: function onClose() {
          _this2.setState({
            pillOpen: false
          });
        },
        replaceParentOn: {
          event: 'results',
          target: '_self'
        }
      }), React.createElement(Inner, null, React.createElement(Section, {
        bottomMargin: bottomMargin || false
      }, React.createElement(SrriScale, {
        value: srri,
        size: "medium",
        withTitle: true
      }), userRisk ? React.createElement(InvestorProfile, null, "Mi perfil de riesgo es:", ' ', theme.partner.user.actions ? React.createElement(AppLink, {
        href: investorProfile,
        "data-fi-event": "product-userRiskProfile"
      }, userRisk.label.toLowerCase()) : React.createElement(Fragment, null, userRisk.label.toLowerCase())) : React.createElement("div", null, React.createElement(AppLink, {
        "data-fi-event": "product-userRiskProfile",
        href: pill,
        onClick: this.handlePillLinkClick
      }, "Conoce tu perfil inversor")))));
    }
  }]);
  return FundSRRI;
}(React.Component);
export default withTheme(FundSRRI);